export default __webpack_public_path__ + "f4d1e07d0d4564718aed0b177ee24d71.woff2";